import { render, staticRenderFns } from "./businessView.vue?vue&type=template&id=28cfbdd8&scoped=true&"
import script from "./businessView.vue?vue&type=script&lang=js&"
export * from "./businessView.vue?vue&type=script&lang=js&"
import style0 from "./businessView.vue?vue&type=style&index=0&id=28cfbdd8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cfbdd8",
  null
  
)

export default component.exports